import React from 'react'

const Logo = ({ className, color }) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 389.3 114.7" className={className} fill={color}>
    <path className="st0" d="M321.8,19.4h26.6c12.9,0,20.1,8.9,20.1,19.4s-7.3,19.4-20.1,19.4h-17.1v24.3h-9.4V19.4z M347.1,27.8h-15.9v22.1
      h15.9c6.8,0,11.6-4.4,11.6-11.1C358.7,32.2,353.9,27.8,347.1,27.8z"/>
    <path className="st0" d="M375.4,19.4h9.5v63h-9.5V19.4z" />
    <path d="M101.8,83.7l-8.4-19.6h-7.2v19.6h-19V19.4h33.5c14.7,0,22.6,10,22.6,22.1c0,11.1-6.3,17-11.3,19.5l11.4,22.7H101.8z
      M104.1,42.7c0-4.4-3-6.3-6.2-6.3H86.3v12.8h11.6C101.1,49.1,104.1,47.2,104.1,42.7z"/>
    <path d="M156.9,83.7V19.4h47.8v17H176V45h28v17h-28v21.7H156.9z" />
    <path d="M0,83.7V19.4h28.2c19.9,0,34.6,11.6,34.6,32.1c0,20.5-14.8,32.2-34.6,32.2H0z M43.5,51.5c0-8.7-4.9-15.1-15.1-15.1h-9.2
      v30.4h9.1C37.8,66.7,43.5,59.6,43.5,51.5z"/>
    <g>
      <path d="M129.2,83.8V19.4h19.5v64.4H129.2z" />
    </g>
    <polygon className="st0" points="291.9,19.4 288.5,19.4 286.3,28.5 298.7,61 278.1,61 276,69.4 301.4,69.4 306.5,82.5 316.9,82.5 " />
    <polygon points="245.5,83.7 245.5,36.4 257.9,36.4 262.2,19.4 209.5,19.4 209.5,36.4 226.4,36.4 226.4,83.7 " />
  </svg>
)

export default Logo
